/**
 * Login Validation: 
 */

import { dId, confirm_box } from "./common.js";

const forget_pass       = <HTMLElement>dId("forget_pass");
const didnt_forget_pass = <HTMLElement>dId("didnt_forget_pass");
const password_form     = <HTMLElement>dId("password_form");
const login_form        = <HTMLElement>dId("login_form");
const login_form_inputs = <HTMLElement>dId("login_form_inputs");
const password_form_inputs = <HTMLElement>dId("password_form_inputs");

//  Loader:  Shortcut - forget password, show password form:
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('forget')) {
  password_form.style.display = "block";
  login_form.style.display = "none";
}

// Listeners: 
login_form_inputs.addEventListener("submit", function (e) {
  e.preventDefault();
  if (checklogin() ) {
    (<HTMLFormElement>e.target).submit();
  }
});

password_form_inputs.addEventListener("submit", function (e) {
  e.preventDefault();
  if (resetlogin() ) {
    (<HTMLFormElement>e.target).submit();
  }

});


forget_pass.addEventListener("click", function () {
  password_form.style.display = "block";
  login_form.style.display = "none";
});

didnt_forget_pass.addEventListener("click", function () {
  password_form.style.display = "none";
  login_form.style.display = "block";
});


function checklogin() {

  const user = (<HTMLInputElement>dId("usuario")).value;
  const pass = (<HTMLInputElement>dId("contrasena")).value;

  if (user.length < 3) {
    confirm_box("Please enter a valid username", "OK", "", "", "");
    return false;
  }

  if (pass.length < 5) {
    confirm_box("Please enter a valid password", "OK", "", "", "");
    return false;
  }

  return true;

}


function resetlogin() {

  const mail = (<HTMLInputElement>dId("user_email")).value;

  // Check valid email format:
  const mail_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  if (!mail_regex.test(mail)) {
    confirm_box("Please enter a valid email address", "OK", "", "", "");
    return false;
  }

  return true;

}

function resetlogin_sent( sent: boolean){
  if (sent){
    confirm_box("We have sent a password reset link to your email address.\nPlease confirm your new password within 30 minutes.", "OK", "", "", "");
  } else {
    confirm_box("Your request was not processed.\nPlease try again (Multiple requests will be blocked).", "OK", "", "", "");
  }
}

// Assign function to global scope (so can be called from inline js):

// @ts-ignore
window.resetlogin_sent = resetlogin_sent;

export { checklogin, resetlogin };